import { createAction } from '@reduxjs/toolkit';

export const uploadStoreWithLocalStorage = createAction(
  'storage/uploadStoreWithLocalStorage',
);
